module.exports = __webpack_public_path__ + "gs.svg?1067356806f9346264da936cc4c9e120";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/gs.svg
// module id = 1389
// module chunks = 0